import { Component } from '@angular/core';
import { environmentCommon } from 'src/environments/environment-common';
import { URLS } from '../../../../data/navigation/navigation.data';
import { LANGMI_PRIVACY_LANGUAGES } from '../../../../data/langmi/langmi-privacy-i18n.data';

@Component( {
  selector: 'app-langmi-privacy-page',
  templateUrl: './langmi-privacy-page.component.html',
  styleUrls: [ './langmi-privacy-page.component.scss' ]
} )
export class LangmiPrivacyPageComponent {

  URLS = URLS;

  // the same policy in the app's other languages (langmi-privacy-localized-page)
  LANGUAGES = LANGMI_PRIVACY_LANGUAGES;

  environmentCommon = environmentCommon;

  constructor() {
    // Intentionally Blank
  }
}
